import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE, getManagerToken } from "../lib/api";
import { ImageIcon } from "lucide-react";

/** Lazy-loaded manager-authed selfie preview. */
export default function SelfiePreview({ scanId, size = 56, className = "" }) {
  const [state, setState] = useState("idle"); // idle | loading | ok | none | error
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let alive = true;
    let objectUrl = null;
    const fetch = async () => {
      const token = getManagerToken();
      if (!token || !scanId) return;
      setState("loading");
      try {
        const r = await axios.get(`${API_BASE}/attendance/scans/${scanId}/selfie`, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        });
        if (!alive) return;
        objectUrl = URL.createObjectURL(r.data);
        setUrl(objectUrl);
        setState("ok");
      } catch (e) {
        if (!alive) return;
        const code = e?.response?.status;
        setState(code === 404 ? "none" : "error");
      }
    };
    fetch();
    return () => { alive = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [scanId]);

  const boxStyle = { width: size, height: size };
  if (state === "ok" && url) {
    return <img data-testid={`selfie-${scanId}`} src={url} alt="selfie" style={boxStyle} className={`object-cover border border-neutral-300 ${className}`} />;
  }
  return (
    <div
      style={boxStyle}
      data-testid={`selfie-${scanId}-empty`}
      className={`flex items-center justify-center border border-neutral-200 bg-neutral-100 text-neutral-400 ${className}`}
      title={state === "none" ? "No selfie stored" : state === "error" ? "Failed to load" : "Loading…"}
    >
      <ImageIcon size={Math.max(14, size * 0.3)} strokeWidth={1.5} />
    </div>
  );
}
